"use client";

import { c as _c } from "react/compiler-runtime";
import { DropSize, Drop as DropType, ExtendedDrop } from "@/helpers/waves/drop.helpers";
import { ActiveDropState } from "@/types/dropInteractionTypes";
import WaveDrop from "./WaveDrop";
import { ApiDrop } from "@/generated/models/ApiDrop";
import { ApiDropType } from "@/generated/models/ApiDropType";
import ParticipationDrop from "./participation/ParticipationDrop";
import WinnerDrop from "./winner/WinnerDrop";
import DropContext from "./DropContext";
import { useMemo } from "react";
export interface DropInteractionParams {
  drop: ExtendedDrop;
  partId: number;
}
export enum DropLocation {
  MY_STREAM = "MY_STREAM",
  WAVE = "WAVE",
  PROFILE = "PROFILE",
}
interface DropProps {
  readonly drop: ExtendedDrop;
  readonly previousDrop: DropType | null;
  readonly nextDrop: DropType | null;
  readonly showWaveInfo: boolean;
  readonly activeDrop: ActiveDropState | null;
  readonly showReplyAndQuote: boolean;
  readonly location: DropLocation;
  readonly dropViewDropId: string | null;
  readonly onReply: (param: DropInteractionParams) => void;
  readonly onQuote: (param: DropInteractionParams) => void;
  readonly onReplyClick: (serialNo: number) => void;
  readonly onQuoteClick: (drop: ApiDrop) => void;
  readonly onDropContentClick?: ((drop: ExtendedDrop) => void) | undefined;
  readonly parentContainerRef?: React.RefObject<HTMLElement | null> | undefined;
}
export default function Drop(t0) {
  const $ = _c(50);
  const {
    drop,
    previousDrop,
    nextDrop,
    showWaveInfo,
    activeDrop,
    location,
    dropViewDropId,
    onReply,
    onQuote,
    onReplyClick,
    onQuoteClick,
    onDropContentClick,
    showReplyAndQuote,
    parentContainerRef
  } = t0;
  let t1;
  if ($[0] !== activeDrop || $[1] !== drop || $[2] !== location || $[3] !== onDropContentClick || $[4] !== onQuote || $[5] !== onQuoteClick || $[6] !== onReply || $[7] !== parentContainerRef || $[8] !== showReplyAndQuote || $[9] !== showWaveInfo) {
    t1 = <ParticipationDrop drop={drop} showWaveInfo={showWaveInfo} activeDrop={activeDrop} location={location} onReply={onReply} onQuote={onQuote} onQuoteClick={onQuoteClick} onDropContentClick={onDropContentClick} showReplyAndQuote={showReplyAndQuote} parentContainerRef={parentContainerRef} />;
    $[0] = activeDrop;
    $[1] = drop;
    $[2] = location;
    $[3] = onDropContentClick;
    $[4] = onQuote;
    $[5] = onQuoteClick;
    $[6] = onReply;
    $[7] = parentContainerRef;
    $[8] = showReplyAndQuote;
    $[9] = showWaveInfo;
    $[10] = t1;
  } else {
    t1 = $[10];
  }
  let t2;
  if ($[11] !== activeDrop || $[12] !== drop || $[13] !== dropViewDropId || $[14] !== location || $[15] !== nextDrop || $[16] !== onDropContentClick || $[17] !== onQuote || $[18] !== onQuoteClick || $[19] !== onReply || $[20] !== onReplyClick || $[21] !== parentContainerRef || $[22] !== previousDrop || $[23] !== showReplyAndQuote || $[24] !== showWaveInfo) {
    t2 = <WinnerDrop drop={drop} previousDrop={previousDrop} nextDrop={nextDrop} showWaveInfo={showWaveInfo} activeDrop={activeDrop} location={location} dropViewDropId={dropViewDropId} onReply={onReply} onQuote={onQuote} onReplyClick={onReplyClick} onQuoteClick={onQuoteClick} onDropContentClick={onDropContentClick} showReplyAndQuote={showReplyAndQuote} parentContainerRef={parentContainerRef} />;
    $[11] = activeDrop;
    $[12] = drop;
    $[13] = dropViewDropId;
    $[14] = location;
    $[15] = nextDrop;
    $[16] = onDropContentClick;
    $[17] = onQuote;
    $[18] = onQuoteClick;
    $[19] = onReply;
    $[20] = onReplyClick;
    $[21] = parentContainerRef;
    $[22] = previousDrop;
    $[23] = showReplyAndQuote;
    $[24] = showWaveInfo;
    $[25] = t2;
  } else {
    t2 = $[25];
  }
  const t3 = previousDrop?.type === DropSize.FULL ? previousDrop : null;
  const t4 = nextDrop?.type === DropSize.FULL ? nextDrop : null;
  let t5;
  if ($[26] !== activeDrop || $[27] !== drop || $[28] !== dropViewDropId || $[29] !== location || $[30] !== onDropContentClick || $[31] !== onQuote || $[32] !== onQuoteClick || $[33] !== onReply || $[34] !== onReplyClick || $[35] !== showReplyAndQuote || $[36] !== showWaveInfo || $[37] !== t3 || $[38] !== t4) {
    t5 = <WaveDrop drop={drop} previousDrop={t3} nextDrop={t4} showWaveInfo={showWaveInfo} activeDrop={activeDrop} location={location} dropViewDropId={dropViewDropId} onReply={onReply} onQuote={onQuote} onReplyClick={onReplyClick} onQuoteClick={onQuoteClick} onDropContentClick={onDropContentClick} showReplyAndQuote={showReplyAndQuote} />;
    $[26] = activeDrop;
    $[27] = drop;
    $[28] = dropViewDropId;
    $[29] = location;
    $[30] = onDropContentClick;
    $[31] = onQuote;
    $[32] = onQuoteClick;
    $[33] = onReply;
    $[34] = onReplyClick;
    $[35] = showReplyAndQuote;
    $[36] = showWaveInfo;
    $[37] = t3;
    $[38] = t4;
    $[39] = t5;
  } else {
    t5 = $[39];
  }
  let t6;
  if ($[40] !== t1 || $[41] !== t2 || $[42] !== t5) {
    t6 = {
      [ApiDropType.Participatory]: t1,
      [ApiDropType.Winner]: t2,
      [ApiDropType.Chat]: t5
    };
    $[40] = t1;
    $[41] = t2;
    $[42] = t5;
    $[43] = t6;
  } else {
    t6 = $[43];
  }
  const components = t6;
  let t7;
  if ($[44] !== drop || $[45] !== location) {
    t7 = {
      drop,
      location
    };
    $[44] = drop;
    $[45] = location;
    $[46] = t7;
  } else {
    t7 = $[46];
  }
  const memoizedValue = t7;
  const t8 = components[drop.drop_type];
  let t9;
  if ($[47] !== memoizedValue || $[48] !== t8) {
    t9 = <DropContext.Provider value={memoizedValue}>{t8}</DropContext.Provider>;
    $[47] = memoizedValue;
    $[48] = t8;
    $[49] = t9;
  } else {
    t9 = $[49];
  }
  return t9;
}